import { render, staticRenderFns } from "./CreateGoods.vue?vue&type=template&id=08541fb6&scoped=true&"
import script from "./CreateGoods.vue?vue&type=script&lang=js&"
export * from "./CreateGoods.vue?vue&type=script&lang=js&"
import style0 from "./CreateGoods.vue?vue&type=style&index=0&id=08541fb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08541fb6",
  null
  
)

export default component.exports